import React, {useContext, useEffect, useState} from 'react';
import './BalanceSheet.scss';
import DynaSelectBox from "../../DynaView/DynaSelectBox";
import DynaInput from "../../DynaView/DynaInput";
import DynaButton from "../../DynaView/DynaButton";
import BalanceSheetTable from "./BalanceSheetTable";
import _axios from "../../../../httpService";
import {prefixUrl} from "../../../../utils/utilsData";
import {toast} from "react-toastify";
import DynaDatePicker from "../../DynaView/DynaDatePicker";
import {SetPrintDataContext} from "../../../../Pages";
import {useNavigate} from "react-router-dom";
import utilsFunction from "../../../../utils/utilsFunction";
import {exportXLSXFile} from "../../../../utils/exportCSVFile";

const BalanceSheet = () => {

  const setprint = useContext(SetPrintDataContext);
  let navigate = useNavigate();
  const [documentNumberFilter, setDocumentNumberFilter] = useState({
    firstId: "",
    lastId: "",
  })
  const [initialData, setInitialData] = useState({})
  const [reportType, setReportType] = useState(0)
  const [dateFilter, setDateFilter] = useState({
    type: "all",
    startDate: "",
    endDate: "",
    year: "",
    month: "",
  })
  const [isLoad, setIsLoad] = useState(false);
  const [yearAndMonth, setYearAndMonth] = useState({
    years: [],
    months: []
  })
  const filterType = [
    {value: "all", label: "نمایش همه"},
    {value: "yearMonth", label: "بر اساس سال و ماه"},
    {value: "date", label: "بر اساس بازه زمانی"},
  ]

  const getInitialData = async () => {
    setIsLoad(false)
    const response = await _axios.get(prefixUrl() + "/accountingBalanceSheet/?request=balanceSheetData_2&dateFilter=" + JSON.stringify(dateFilter) + "&documentNumberFilter=" + JSON.stringify(documentNumberFilter) + "&reportType=" + reportType)
    if (response?.data?.status) {
      setInitialData(response.data.data)
      setIsLoad(true)
    } else {
      toast.error(response.data.message)
    }
  }

  const getYearAndMonth = async () => {
    const response = await _axios.get(prefixUrl() + "/accountingTreeChart/?request=submittedYearAndMonth_2")
    if (response.data.status) {
      setYearAndMonth({years: response?.data?.years, months: [], data: response?.data?.data})
    } else {
      toast.error(response.data.message)
    }
  }

  useEffect(() => {
    void getYearAndMonth()
  }, []);

  useEffect(() => {
    void getInitialData()
  }, [reportType]);

  const filterHandel = () => {
    void getInitialData()
  }

  useEffect(() => {
    if (dateFilter?.year !== "") {
      yearAndMonth?.data.forEach((v) => {
        if (+v?.year === +dateFilter?.year) {
          setYearAndMonth({...yearAndMonth, months: v?.month})
          setDateFilter({...dateFilter, month: ""})
        }
      })
    }
  }, [dateFilter?.year]);

  const printHandel = () => {
    const sendData = {
      type: "BalanceSheetPrint",
      data: {
        dateFilter: dateFilter,
        documentNumberFilter: documentNumberFilter,
        mainData: initialData,
        reportType: reportType
      },
    };
    setprint(sendData);
    navigate("/factorprint");
  }

  const letGoXLSTwo = () => {

    const format = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
    };
    debugger
    const fileName = "تراز نامه " + new Date().toLocaleDateString("fa-ir", format);
    const normalizeData = utilsFunction.convertTabulatorDataToJson(initialData?.column, initialData?.data)
    exportXLSXFile(normalizeData, fileName, "")
  }

  return (
    <section className={"main-balance-sheet"}>

      <div className={"row-filter"}>
        <DynaSelectBox options={filterType}
                       hasFilter={false}
                       label={"نوع فیلتر"}
                       className={"solid-dyna-input"}
                       value={dateFilter?.type}
                       onChange={(data) => setDateFilter({
                         type: data.value,
                         startDate: "",
                         endDate: "",
                         year: "",
                         month: "",
                       })}
        />

        {dateFilter?.type === "date" &&
          <>
            <DynaDatePicker label={"تاریخ شروع"}
                            name={"startDate"}
                            className={"solid-dyna-input"}
                            value={dateFilter?.startDate}
                            setDataFromComponent={(data) => {
                              setDateFilter({...dateFilter, ...data})
                            }}
            />
            <DynaDatePicker label={"تاریخ پایان"}
                            name={"endDate"}
                            className={"solid-dyna-input"}
                            value={dateFilter?.endDate}
                            setDataFromComponent={(data) => {
                              setDateFilter({...dateFilter, ...data})
                            }}
            />
          </>
        }

        {dateFilter?.type === "yearMonth" &&
          <>
            <DynaSelectBox options={yearAndMonth?.years}
                           hasFilter={false}
                           label={"سال"}
                           className={"solid-dyna-input"}
                           value={dateFilter?.year}
                           onChange={(data) => setDateFilter({...dateFilter, year: data.value})}
            />
            <DynaSelectBox options={yearAndMonth?.months}
                           hasFilter={false}
                           label={"ماه"}
                           className={"solid-dyna-input"}
                           value={dateFilter?.month}
                           onChange={(data) => setDateFilter({...dateFilter, month: data.value})}
            />
          </>
        }

        <DynaInput label={"از شماره سند"}
                   name={"firstId"}
                   className={"solid-dyna-input"}
                   placeholder={"شماره سند را وارد کنید"}
                   value={documentNumberFilter?.firstId}
                   type={"number"}
                   setDataFromComponent={(data) => {
                     setDocumentNumberFilter({...documentNumberFilter, ...data})
                   }}
        />
        <DynaInput label={"تا شماره سند"}
                   name={"lastId"}
                   className={"solid-dyna-input"}
                   placeholder={"شماره سند را وارد کنید"}
                   value={documentNumberFilter?.lastId}
                   type={"number"}
                   setDataFromComponent={(data) => {
                     setDocumentNumberFilter({...documentNumberFilter, ...data})
                   }}
        />

        <DynaButton className={"simple-but-no-bac"}
                    type={"button"}
                    onClick={filterHandel}>اعمال فیلتر</DynaButton>
      </div>

      <div className={"table-but-row"}>
        <button style={reportType === 0 ? {backgroundColor: '#D9DCEA'} : {}}
                onClick={() => setReportType(0)}> گروه
        </button>
        <button style={reportType === 1 ? {backgroundColor: '#D9DCEA'} : {}}
                onClick={() => setReportType(1)}> کل
        </button>
        <button style={reportType === 2 ? {backgroundColor: '#D9DCEA'} : {}}
                onClick={() => setReportType(2)}> معین
        </button>
      </div>

      <BalanceSheetTable initialData={initialData} isLoad={isLoad}/>

      {isLoad &&
        <div className={"row-button"}>
          <DynaButton className={"simple-but-no-bac"}
                      type={"button"}
                      onClick={printHandel}>پرینت</DynaButton>
          <DynaButton className={"simple-but-no-bac"}
                      type={"button"}
                      onClick={letGoXLSTwo}>دانلود اکسل</DynaButton>

        </div>
      }
    </section>
  );
};

export default BalanceSheet;